import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Madres de niños con autismo (4-10 años) que sufren crisis frecuentes.', 'Mamás latinas en USA que se sienten juzgadas en lugares públicos.', 'Madres agotadas que sienten que ya no tienen paciencia para lidiar con el próximo colapso.', "Cuidadoras que buscan una solución práctica que funcione en el 'mundo real'."];
const notForWho = ["Personas que buscan una 'cura' para el autismo (el autismo no se cura, se comprende).", 'Casos de agresividad severa que representen un peligro físico inmediato.', 'Padres que no están dispuestos a cambiar su propia forma de reaccionar ante el niño.'];
export function WhoIsThisFor() {
  return <section className="bg-white py-20 px-6" data-id="element-192">
      <div className="max-w-5xl mx-auto" data-id="element-193">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-194">
          {/* Para ti si... */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-cream p-8 rounded-2xl border border-teal/20" data-id="element-195">
            <h3 className="text-2xl font-serif font-bold text-navy mb-6 flex items-center gap-3" data-id="element-196">
              <span className="bg-teal/10 text-teal p-2 rounded-full" data-id="element-197">
                <Check className="w-6 h-6" data-id="element-198" />
              </span>
              Este protocolo ES para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-199">
              {forWho.map((text, i) => <li key={i} className="flex gap-3 items-start" data-id="element-200">
                  <Check className="w-5 h-5 text-teal shrink-0 mt-0.5" data-id="element-201" />
                  <span className="text-gray-700" data-id="element-202">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si... */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-203">
            <h3 className="text-2xl font-serif font-bold text-gray-500 mb-6 flex items-center gap-3" data-id="element-204">
              <span className="bg-gray-200 text-gray-500 p-2 rounded-full" data-id="element-205">
                <X className="w-6 h-6" data-id="element-206" />
              </span>
              NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-207">
              {notForWho.map((text, i) => <li key={i} className="flex gap-3 items-start" data-id="element-208">
                  <X className="w-5 h-5 text-gray-400 shrink-0 mt-0.5" data-id="element-209" />
                  <span className="text-gray-600" data-id="element-210">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}